<template>
    <v-row>
        <v-spacer></v-spacer>
        <v-col sm="auto">
            <v-btn
                class="mr-1"
                color="purple"
                :dark="(previous !== undefined) && !disableClientNavigation"
                :disabled="(previous === undefined) || disableClientNavigation"
                @click="changeClient(previous)"
            >
                <v-icon>navigate_before</v-icon>
                {{ $t('common.previous') }}
            </v-btn>
            <v-btn
                class="ml-1"
                color="purple"
                :dark="(next !== undefined) && !disableClientNavigation"
                :disabled="(next === undefined) || disableClientNavigation"
                @click="changeClient(next)"
            >
                {{ $t('common.next') }}
                <v-icon>navigate_next</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import API from '@/api'

export default {
    name: 'client-navigator',
    props: ['current', 'disabled', 'singleName'],
    data () {
        return {
            previous: undefined,
            next: undefined,
            tempAllClient: []
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        disableClientNavigation () {
            return window.getApp.disableClientNavigation
        }
    },
    methods: {
        loadData (skip) {
            if (skip == null) {
                skip = 0
                this.tempAllClient = []
            }
            let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let endpoint = API.EndPoints.getAllClientIds
            let sortView = JSON.parse(localStorage.getItem('clientSort'))
            let params = {
                limit: 100,
                order: sortView.order,
                showInactives: sortView.showInactives,
                skip: skip,
                parent: currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId,
                onlyManaged: true
            }
            new API(endpoint, params).request().then(response => {
                this.tempAllClient = this.tempAllClient.concat(response.data.result.results)
                if (this.tempAllClient.length < response.data.result.count) {
                    return this.loadData(skip + 1)
                }
                this.tempAllClient.map((id, index) => {
                    if (id === this.current) {
                        let currentPos = this.tempAllClient.indexOf(id)
                        this.previous = (currentPos > 0) ? this.tempAllClient[currentPos - 1] : undefined
                        this.next = (currentPos < this.tempAllClient.length) ? this.tempAllClient[currentPos + 1] : undefined
                    }
                })
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        changeClient (clientId) {
            if (clientId === undefined) return
            window.getApp.refreshDemands = true
            this.$router.push({ name: `${this.singleName}AbaInternaDemandasAtivas`, params: { id: clientId } }).catch(e => {})
        }
    }
}
</script>
